import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import { NbToastrService } from "@nebular/theme";
import { User } from "../../shared/models/user.model";
import { AuthService } from "../../shared/services/auth/auth.service";
import { Roles } from "../../shared/utils/role.enum";
import { OptionsHttpProviderService } from "../../shared/services/options/options-http-provider.service";
import { NbTokenService } from "@nebular/auth";
import { HospitalHttpProviderService } from "../../shared/services/hospital/hospital-http-provider.service";
import jwt_decode from "jwt-decode";

@Component({
  selector: "ngx-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
})
export class RegisterComponent implements OnInit {
  error: any;
  user: User;
  roles: string[] = Object.values(Roles);
  selectedRole = new FormControl(Roles.HospitalStaff);

  token: string;
  email: string;
  role: string;
  rolesEnum = Roles;
  hospitals: any[] = [{ _id: 1, name: "testhospital" }];
  selectedHospital = new FormControl("");

  registerForm = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email]),
    password: new FormControl("", [
      Validators.required,
      Validators.minLength(8),
    ]),
    username: new FormControl("", [Validators.required]),
    firstName: new FormControl(""),
    lastName: new FormControl(""),
    phone: new FormControl("", [
      Validators.pattern(/^[0-9]{8,}$/), // Use pattern validation to ensure 8 digits
    ]),
    role: this.selectedRole,
    token: new FormControl(""),
    vat_num: new FormControl(""),
    job: new FormControl(""),
    company_adress: new FormControl(""),
    hospitals: new FormControl([]),
    affectedBy: new FormControl(""),
  });
  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private toastrService: NbToastrService,
    private route: ActivatedRoute,
    private hospitalService: HospitalHttpProviderService,
    private tokenService: NbTokenService
  ) {}
  ngOnInit(): void {
    // clear token
    this.tokenService.clear().subscribe(() => {
      console.log("token cleared");
    });

    // get token, role and email from url
    this.token = this.route.snapshot.paramMap.get("token");

    // verify token
    this.authService.verifyToken(this.token).subscribe(
      (result) => {},
      (err) => {
        this.toastrService.danger("Invalid token", "Error");
        this.router.navigate(["/"]);
        console.log(err);
      }
    );

    // get data from token
    const { email, role, hospitals, affectedBy } = this.getDataFromToken(
      this.token
    );
    email ? (this.email = email) : null;
    role ? (this.role = role) : null;

    // update register form
    this.registerForm.patchValue({
      email: this.email,
      token: this.token,
      role: this.role,
      hospitals: hospitals,
      affectedBy: affectedBy,
    });

    // if role is hospital staff, fetch hospitals in order to choose from them
    if (this.role == this.rolesEnum.HospitalStaff) {
      this.fetchHospitals();
    }
  }
  getDataFromToken(_token): any {
    const decodedToken = jwt_decode(_token);
    //console.log(decodedToken);
    return decodedToken;
  }

  onSubmit(): void {
    // if role is hospital staff, add hospital to register form
    if (this.role == this.rolesEnum.HospitalStaff) {
      // update register form
      this.registerForm.patchValue({
        hospitals: [this.selectedHospital.value],
      });
    }

    this.authService.register(this.registerForm.value).subscribe(
      (result) => {
        this.toastrService.success("account created successfully", "success");
        this.router.navigate(["/", "login"]);
      },
      (error) => {
        this.toastrService.danger("account creation failed", "error");
        console.log(error);
        this.error = error;
      }
    );
  }
  fetchHospitals() {
    this.hospitalService.getAllHospitals().subscribe(
      (data) => {
        this.hospitals = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
